/* eslint-disable */
// import * as baseSpu from './baseSpu';
// import * as category from './category';
// import * as util from './unit';
import * as createNewProduct from './createNewProduct';

const keys = {};
const exportObj = {};
let services = {
    // baseSpu,
    // category,
    // util,
    createNewProduct
};

Object.keys(services).forEach(item => {
    Object.keys(services[item]).forEach(key => {
        if (keys[key]) {
            throw `Service 名称重复: ${item}下的名称${key}和${
                keys[key]
            }下的${key}重复`;
        }
        exportObj[key] = services[item][key];
        keys[key] = item;
    });
});

export default exportObj;
